<template>
  <div v-if="org" class="base-info">
    <el-row class="all">
      <div v-for="item in statisticsColumns" :key="item.prop">
        <div>{{statistics[item.prop] || 0}}</div>
        <div>{{item.label}}</div>
      </div>
    </el-row>

    <el-descriptions title="基本信息" :column="3" border>
      <el-descriptions-item v-for="column in columns.base" :key="column.key" label-align="right" align="center"
        label-class-name="base-info-item-label" :span="column.span" :label="column.label">
        {{column.formatter ? column.formatter(org) : org[column.key]}}
      </el-descriptions-item>
      <el-descriptions-item  label-align="right" align="center" label-class-name="base-info-item-label" span="3" label="营业执照"
        v-if="org.businessLicensePath">
        <el-image :src="getFileUrl(org.businessLicensePath)" :preview-src-list="[getFileUrl(org.businessLicensePath)]"
          style="width: 200px; height: 200px">
        </el-image>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions title="管理信息" :column="3" border>
      <el-descriptions-item label-align="right" align="center" label-class-name="info-item-label" label="审核状态">
        <el-tag v-if="org.auditStatus === 0">待审核</el-tag>
        <el-tag v-else-if="org.auditStatus === 1" type="success">审核通过</el-tag>
        <el-tag v-else-if="org.auditStatus === 2" type="danger">审核驳回</el-tag>
      </el-descriptions-item>
      <el-descriptions-item v-for="column in columns.manage" :key="column.key" label-align="right" align="center"
        label-class-name="base-info-item-label" :span="column.span" :label="column.label">
        {{column.formatter ? column.formatter(org) : org[column.key]}}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { getFileUrl } from '@/utils/common';
import { getStatisticsByOrgId } from '@/api/sys/org';

export default defineComponent({
  props: {
    org: Object
  },
  data() {
    return {
      getFileUrl,
      id: null,
      statistics: {},
      statisticsColumns: [
        { prop: 'projectNum', label: '项目总数' },
        { prop: 'projectCompletedNum', label: '已完工项目' },
        { prop: 'projectUncompletedNum', label: '未完工项目' },
        { prop: 'userNum', label: '项目总人数' }
      ],
      columns:{
        base: [
          { label: '企业名称', key: 'fullName' },
          { label: '企业简称', key: 'name' },
          { label: '联系人', key: 'contactName' },
          { label: '联系电话', key: 'contactPhone' },
          { label: '统一信用代码', key: 'unifiedCreditCode' },
          { label: '申请人', key: 'registrationUserName' },
          { label: '申请时间', key: 'registrationTimeString' },
          { label: '修改人', key: 'updateUserName' },
          { label: '修改时间', key: 'updateTimeString' },
          { label: '经营范围', key: 'introduce', span: 3 }
        ],
        manage: [
          { label: '是否启用', key: 'enabled', formatter: (o) => o.enabled ? '是' : '否'  },
          { label: '是否长期有效', key: 'isEffective', formatter: (o) => o.isEffective ? '是' : '否' },
          { label: '审核时间', key: 'auditTimeString' },
          { label: '有效开始日期', key: 'effectiveStartDate' },
          { label: '有效结束日期', key: 'effectiveEndDate' },
          { label: '审核意见', key: 'opinion', span: 3 }

        ]
      }
    };
  },
  methods: {
    getStatistics() {
      getStatisticsByOrgId(this.id).then(({data}) => {
        this.statistics = data.data || {};
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    if (!this.id) {
      return;
    }
    this.getStatistics();
  }
})
</script>

<style lang="scss" scoped>
.base-info {
  .all {
    >div {
      background-color: #409eff;
      color: #fff;
      text-align: center;
      width: calc(25% - 1px);
      >div {
        padding: 8px 0;
        & + div {
          font-size: 1.1em;
        }
      }
      & + div {
        border-left: 1px solid #fff;
      }
    }
  }
  .el-descriptions {
    margin-top: 25px;
    .el-image {
      width: 250px;
      height: 150px;
    }
    .el-image + .el-image {
      margin-left: 25px;
    }
  }
}
</style>
<style lang="scss">
.base-info-item-label {
  width: 120px;
}
</style>
